/* Insmia PRODUCT|MODEL card view toggle (display-layer only; media order untouched) */
(function () {
  var KEY = 'ins-card-view';

  function getMode() {
    try { return localStorage.getItem(KEY) === 'model' ? 'model' : 'product'; } catch (e) { return 'product'; }
  }

  function applyCard(card) {
    var s = card.querySelector('slideshow-component');
    if (!s) return;
    if (card.querySelectorAll('slideshow-slide:not([hidden])').length < 2) return;
    var idx = getMode() === 'model' ? '1' : '0';
    /* 声明式停靠:initial-slide 属性是主题初始化 rAF 与 morph 后 re-select 的读取源 ——
       钉住它,分页新卡/筛选 morph 都由主题自己停到基准帧(外部 select 抢不过 init rAF)。
       属性没变化时(attributeChangedCallback 不触发)再补一发运行时 select 兜底。 */
    if (s.getAttribute('initial-slide') !== idx) {
      s.setAttribute('initial-slide', idx);
    } else if (typeof s.select === 'function') {
      try { s.select(parseInt(idx, 10), undefined, { animate: false }); } catch (e) {}
    }
  }

  function applyAll() {
    document.querySelectorAll('product-card').forEach(applyCard);
  }

  function syncUI() {
    document.querySelectorAll('.ins-view-toggle button').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-v') === getMode());
    });
  }

  function setMode(m) {
    try { localStorage.setItem(KEY, m); } catch (e) {}
    document.documentElement.setAttribute('data-ins-view', m);
    applyAll();
    syncUI();
  }

  function buildUI() {
    if (document.querySelector('.ins-view-toggle')) return;
    var anchor = Array.prototype.find.call(
      document.querySelectorAll('.facets-block-wrapper span, .facets-block-wrapper div, .facets-block-wrapper p'),
      function (e) { return /^\d+\s+items$/i.test((e.textContent || '').trim()) && e.children.length === 0; }
    );
    var ctrl = document.createElement('div');
    ctrl.className = 'ins-view-toggle';
    ctrl.innerHTML = '<button type="button" data-v="product">Product</button>' +
      '<span class="sep">|</span>' +
      '<button type="button" data-v="model">Model</button>';
    ctrl.addEventListener('click', function (ev) {
      var b = ev.target.closest('button[data-v]');
      if (b) setMode(b.getAttribute('data-v'));
    });
    if (anchor && anchor.parentElement) {
      anchor.parentElement.insertBefore(ctrl, anchor);
    } else {
      var bar = document.querySelector('.facets-block-wrapper');
      if (bar) bar.appendChild(ctrl); else return;
    }
  }

  /* 2026-07-16: the old document-level pointerleave re-assert (60ms) is GONE — capture
     phase fired on every child-boundary crossing inside a card, yanking the carousel
     back to slide 1 and killing both hover-preview and swatch-preview in MODEL mode.
     MODEL behaviour now lives in product-card.js (#homeIndex): the theme's own
     preview/reset state machine parks on the on-foot slide natively. */

  // pagination / infinite scroll / section rerender + morph 属性守护
  new MutationObserver(function (muts) {
    var mode = getMode();
    muts.forEach(function (m) {
      /* 筛选 morph 会把 slideshow 的 initial-slide 属性写回渲染值 0(card-gallery 恒 0)
         → 主题 attributeChangedCallback re-select(0) 回白底。守护:model 模式下改回 1,
         属性变化再次驱动主题自己 select(1)。值已是 1 时不写 = 无环。 */
      if (m.type === 'attributes' && mode === 'model' && m.target.nodeType === 1) {
        var t = m.target;
        if (t.tagName === 'SLIDESHOW-COMPONENT' && t.closest('product-card') &&
            t.getAttribute('initial-slide') !== '1' &&
            t.closest('product-card').querySelectorAll('slideshow-slide:not([hidden])').length > 1) {
          t.setAttribute('initial-slide', '1');
        }
        return;
      }
      m.addedNodes && Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('product-card')) { if (mode === 'model') applyCard(n); }
        else if (n.querySelectorAll) {
          if (!document.querySelector('.ins-view-toggle')) buildUI();
          if (mode === 'model') n.querySelectorAll('product-card').forEach(applyCard);
        }
      });
    });
    syncUI();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['initial-slide'] });

  function init() {
    if (!document.querySelector('.product-grid')) return;
    buildUI();
    document.documentElement.setAttribute('data-ins-view', getMode());
    if (getMode() === 'model') applyAll();
    syncUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(function () { init(); if (getMode() === 'model') applyAll(); }, 900);
  setTimeout(function () { if (getMode() === 'model') applyAll(); }, 2600);
})();
